import LoanCard from "./LoanCard";

export default function LoanSection() {
    const loans = [
        { title: "HOME LOAN", rate: "8.00", icon: "/images/home_ad.webp", path: "/home_loan" },
        { title: "VEHICLE LOAN", rate: "10.00", icon: "/images/vehicle_ad.webp", path: "/vehicle_loan" },
        { title: "CASH CREDIT LOAN", rate: "10.50", icon: "/images/loan3.webp", path: "/cash_credit_loan" },
        { title: "PERSONAL LOAN", rate: "11.10", icon: "/images/personal_ad.webp", path: "/personal_loan" },
        { title: "ECCS LOAN", rate: "9.80", icon: "/images/loan5.webp", path: "/eccs_loan" },
        { title: "SHG LOAN", rate: "2.00", icon: "/images/loan6.webp", path: "/shg_loan" },
        { title: "KCC LOAN", rate: "4.00", icon: "/images/loan7.webp", path: "/kcc_loan" },
        { title: "WORK ORDER LOAN", rate: "10.50", icon: "/images/loan8.webp",path: "/work_order_loan" },
        { title: "TERM LOAN", rate: "Flexi", icon: "/images/loan9.webp" ,path: "/term_loan"},
        { title: "LOAN AGAINST NSC/KVP/LIC", rate: "10.00", icon: "/images/loan10.webp" },
    ];

    return (
        <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6 
                            grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

                {loans.map((loan, i) => (
                    <LoanCard
                        key={i}
                        title={loan.title}
                        rate={loan.rate}
                        icon={loan.icon}
                        path={loan.path}
                    />
                ))}

            </div>
        </section>
    );
}
